import { DropdownOption } from '@equip.health/ui';

export interface BaseTreatmentAttribute {
  id: string;
  treatmentEpisodeId: string;
  startDate: string;
  endDate: string | null;
  noteId: string | null;
  explanation: string;
}
export interface TreatmentAttributeEnum {
  code: string;
  label: string;
  sortOrder: number;
}

export interface DiscussionOfWeightAttribute extends BaseTreatmentAttribute {
  discussionOfWeight: TreatmentAttributeEnum;
}

export interface SaferStageAttribute extends BaseTreatmentAttribute {
  saferStage: TreatmentAttributeEnum;
}

export interface RefeedingRiskAttribute extends BaseTreatmentAttribute {
  refeedingRisk: TreatmentAttributeEnum;
}

export interface TreatmentFormEnumeration extends TreatmentAttributeEnum {
  treatmentPhaseStages: TreatmentAttributeEnum[];
}
export interface TreatmentModalityEnumeration extends TreatmentAttributeEnum {
  // one or the other will be populated, as forms dictate phase stages, if the modality has forms
  treatmentForms: TreatmentFormEnumeration[];
  phaseStages: TreatmentAttributeEnum[];
}

export interface TreatmentLevelEnumeration {
  id: number;
  label: string;
  externalId: string;
  sortOrder: number;
}

export const treatmentAttributeEnumToDropdownOption = (
  tre: TreatmentAttributeEnum,
): DropdownOption => ({
  label: tre.label,
  value: tre.code,
});

export interface TreatmentAttributeLevelEnum {
  id: number;
  label: string;
  sortOrder: number;
}

export interface LevelAttribute extends BaseTreatmentAttribute {
  level: TreatmentAttributeLevelEnum;
}

export interface ModalityAttribute extends BaseTreatmentAttribute {
  modality: TreatmentAttributeEnum;
}

export interface FormAttribute extends BaseTreatmentAttribute {
  form: {
    code: string;
    label: string;
    sortOrder: number;
    modalityCode: string;
  };
}

export interface PhaseStageAttribute extends BaseTreatmentAttribute {
  phaseStage: {
    code: string;
    label: string;
    sortOrder: number;
    treatmentFormCode?: string;
  };
}

export interface MedicalStabilityAttribute extends BaseTreatmentAttribute {
  medicalStability: TreatmentAttributeEnum;
}

export interface PsychiatricStabilityAttribute extends BaseTreatmentAttribute {
  psychiatricStability: TreatmentAttributeEnum;
}

interface TreatmentEpisodeAttributeRequest {
  code: string;
  explanation: string;
}

interface TreatmentEpisodeLevelRequest {
  levelId: number;
  explanation: string;
}

export interface CreateAttributesParams {
  treatmentEpisodeId: string;
  attributes: {
    startDate: string;
    noteId?: string;
    discussionOfWeight?: TreatmentEpisodeAttributeRequest;
    form?: TreatmentEpisodeAttributeRequest;
    level?: TreatmentEpisodeLevelRequest;
    medicalStability?: TreatmentEpisodeAttributeRequest;
    modality?: TreatmentEpisodeAttributeRequest;
    phaseStage?: TreatmentEpisodeAttributeRequest;
    psychiatricStability?: TreatmentEpisodeAttributeRequest;
    refeedingRisk?: TreatmentEpisodeAttributeRequest;
    saferStage?: TreatmentEpisodeAttributeRequest;
  };
}

export interface CreateAttributesResponse {}

export interface GetTreatmentAttributesRequest {
  treatmentEpisodeId: string;
  noteId: string;
}

export interface GetTreatmentAttributesResponse {
  discussionsOfWeight: DiscussionOfWeightAttribute[];
  forms: FormAttribute[];
  levels: LevelAttribute[];
  medicalStabilities: MedicalStabilityAttribute[];
  modalities: ModalityAttribute[];
  phaseStages: PhaseStageAttribute[];
  psychiatricStabilities: PsychiatricStabilityAttribute[];
  refeedingRisks: RefeedingRiskAttribute[];
  saferStages: SaferStageAttribute[];
}
